exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/hassa/Desktop/clientpanel-final/clientpanel_final/src/app/components/client-details/client-details.component.css
// module id = ../../../../../src/app/components/client-details/client-details.component.css
// module chunks = main